<template>
  <section id="testimonial" class="n2-seccion n2-seccion--suave" v-if="NOTARIA?.Theme?.Home?.Testimonios?.Mostrar && lista.length">
    <div class="n2-contenedor">
      <div class="n5-cabeza n2-aparece">
        <h2 class="n5-titulo">{{ tSolicitud('Opiniones') }}</h2>
      </div>
      <div class="n5-opiniones" :class="{ 'n5-opiniones--muchas': lista.length > 2 }">
        <figure v-for="(t, i) in lista" :key="i" class="n5-opinion n2-aparece">
          <div class="n2-estrellas" :aria-label="(Number(t.Estrellas) || 5) + ' / 5'">
            <v-icon v-for="n in (Number(t.Estrellas) || 5)" :key="n" size="18">{{ NOTARIA.Theme.Home.Testimonios.Icon || 'mdi-star' }}</v-icon>
          </div>
          <blockquote>{{ textoPlano(t.Descripcion) }}</blockquote>
          <figcaption>
            <img v-if="t.Imagen" :src="imagenIDtoSRC(t.Imagen)" :alt="t.Nombre" loading="lazy" />
            <span v-else class="n5-opinion__inicial" aria-hidden="true">{{ (t.Nombre || '?').trim().charAt(0).toUpperCase() }}</span>
            {{ t.Nombre }}
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { textoPlano } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC } = useUtils()
// Panel: Testimonios (y su interruptor en Inicio)
const lista = computed(() => NOTARIA.value?.Testimonios ?? [])
</script>
